import React from 'react';
import { Link } from 'react-router-dom';

const DeliveryBanner = () => {
  return (
    <section className="md:mx-10 my-2">
      <div className="bg-[#E3185C] md:rounded-2xl relative overflow-hidden">
        <div className="px-8 py-6 relative z-10">
          <h2 className="text-white text-[25px] font-medium mb-1 max-w-[60%] md:max-w-[70%]">
            Shop now &amp; receive your order in{' '}
            <span className="font-bold">3 to 5 working days!</span>
          </h2>
          <p className="text-white text-sm opacity-90 max-w-[60%] md:max-w-[70%]">
            We deliver in 3-5 working days ( Mon -Fri )
          </p>
        </div>
        {/* Mobile image */}
        <img
          src="/images/shop-now-mobile.min.svg"
          alt="Shop now and get fast delivery"
          className="absolute right-0 top-0 h-full object-cover md:hidden"
        />
        {/* Desktop image */}
        <img
          src="/images/shop-now.min.svg"
          alt="Shop now and get fast delivery"
          className="absolute right-0 top-0 h-full object-cover hidden md:block"
        />
      </div>
    </section>
  );
};

export default DeliveryBanner;
